
























import {
  computed, defineComponent, Ref, ref,
} from '@vue/composition-api';
import dayjs from 'dayjs';

const backwardTenYear = Array.from({ length: 10 }, (x, i) => new Date().getFullYear() + 543 - i);

const currentYear = backwardTenYear[0];

const CommonYearMonthSelector = defineComponent({
  props: {
    value: { default: undefined },
  },
  setup(props, { emit }) {
    const monthThaiShort = [
      'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.',
    ];
    const selectedMonth: Ref<number | undefined> = ref(undefined);
    const selectedYear: Ref<number | undefined | string> = ref(backwardTenYear[0]);

    const computedModelValue = computed(() => {
      if (selectedMonth.value === undefined && selectedYear.value === undefined) {
        return undefined;
      }
      if (selectedMonth.value !== undefined && selectedYear.value === undefined) {
        return {
          from: dayjs().month((selectedMonth.value as any)).startOf('month').format('YYYY-MM-DD'),
          to: dayjs().month((selectedMonth.value as any)).endOf('month').format('YYYY-MM-DD'),
        };
      }
      if (selectedMonth.value === undefined && selectedYear.value !== undefined) {
        return {
          from: dayjs().year((selectedYear.value as any) - 543 || currentYear).startOf('year').format('YYYY-MM-DD'),
          to: dayjs().year((selectedYear.value as any) - 543 || currentYear).endOf('year').format('YYYY-MM-DD'),
        };
      }
      return {
        from: dayjs().year((selectedYear.value as any) - 543 || currentYear).month((selectedMonth.value as any)).startOf('month')
          .format('YYYY-MM-DD'),
        to: dayjs().year((selectedYear.value as any) - 543 || currentYear).month((selectedMonth.value as any)).endOf('month')
          .format('YYYY-MM-DD'),
      };
    });

    function updateMonthHandler($event: number | undefined) {
      selectedMonth.value = $event;
      emit('input', computedModelValue.value);
    }
    function updateYearHandler($event: number | undefined | string) {
      if ($event === 'ทั้งหมด') selectedYear.value = undefined;
      else selectedYear.value = $event;
      emit('input', computedModelValue.value);
    }

    return {
      monthThaiShort,
      backwardTenYear,
      selectedMonth,
      selectedYear,
      updateMonthHandler,
      updateYearHandler,

      computedModelValue,
    };
  },
});

export default CommonYearMonthSelector;
